<template>
  <div
    class="xes-question-single test-main-one"
    :id="group != undefined ? 'questions' + group + index : 'questions' + index"
    :class="{
            on: (activeid.material_id && activeid.material_id == testData.material_id) || (activeid.id && activeid.id == testData.id),
            dropView: dropView,
            disabled: isDisabled()
        }"
    :draggable="move"
    @dragstart.stop="dragStart($event)"
    @dragend.stop="dragEnd($event)"
    @click.stop="dragClick($event)"
  >
    <div class="disabledView"></div>
    <!-- 材料题聚合 -->
    <div v-if="testData.question_list" ref="entity">
      <div class="martial-top">
        <em
          v-if="testOptions.material_id"
          class="martial-id"
          v-html="'材料ID:' + testData.material_id"
        ></em>
        <slot name="topButtons" :data="testData" :index="[index]" :fade="fade"></slot>
      </div>
      <p class="martial-content">
        <b
          v-if="testOptions.index && typeof index == 'number'"
        >{{ serial ? serial + 1 : index + 1 }}.</b>
        <span v-for="(item, index) in material_content" :key="index">
          <audioPlay
            v-if="item.type == 'mp3' && testData.material_audio && testData.material_audio.content && testData.material_audio.content[item.content]"
            :src="testData.material_audio.content[item.content]"
          ></audioPlay>
          <audioPlay
            v-else-if="
                            item.type == 'mp3' &&
                                testData.question_list.length &&
                                testData.question_list[0].material_audio &&
                                testData.question_list[0].material_audio.content &&
                                testData.question_list[0].material_audio.content[item.content]
                        "
            :src="testData.question_list[0].material_audio.content[item.content]"
          ></audioPlay>
          <span v-else v-katex="item.name || item.content"></span>
        </span>
      </p>
      <div class="martial-test martial-test-list">
        <single
          :class="{
                        'test-information-simple': mode == 'simple',
                        on: activeid.id && activeid.id == test.id,
                        dropView: childDropView,
                        activeBg: matchActiveList(test.id),
                        disabled: isDisabled(test.id)
                    }"
          :testOptions="testOptions"
          v-for="(test, num) in testData.question_list"
          :key="test.id"
          :index="num"
          :testData="test"
          ref="single"
          :expand="expand"
          :dropView="childDropView"
          @setDropView="setChildDropView"
          @childDragStart="childDragStart"
          @childDragEnd="childDragEnd"
          @childDragClick="childDragClick"
          @childDrop="childDrop"
          @testOpen="testOpen"
          :move="move"
          :activeid="activeid"
          :operatingfloat="operatingfloat"
          :infoicon="infoicon"
        >
          <template slot="topInfo" slot-scope="{ data, level2 }">
            <slot name="topInfo" :data="data" :index="[index, level2]"></slot>
          </template>
          <template slot="middleInfo" slot-scope="{ data, level2 }">
            <slot name="middleInfo" :data="data" :index="[index, level2]"></slot>
          </template>
          <template slot="bottomInfo" slot-scope="{ data, level2 }">
            <slot name="bottomInfo" :data="data" :index="[index, level2]"></slot>
          </template>
          <template slot="bottomButtons" slot-scope="{ data, level2, fade }">
            <slot name="bottomButtons" :data="data" :index="[index, level2]" :fade="fade"></slot>
          </template>
          <template slot="floatButtons" slot-scope="{ data, level2, fade }">
            <slot name="floatButtons" :data="data" :index="[index, level2]" :fade="fade"></slot>
          </template>
          <template slot="topInfoRight" slot-scope="{ data, level2 }">
            <slot name="topInfoRight" :data="data" :index="[index, level2]"></slot>
          </template>
        </single>
      </div>
    </div>
    <!-- 材料题单题 -->
    <div v-else-if="testData.material_id" ref="entity">
      <div class="martial-top">
        <em
          v-if="testOptions.material_id"
          class="martial-id"
          v-html="'材料ID:' + testData.material_id"
        ></em>
        <slot name="topButtons" :data="testData" :index="[index]" :fade="fade"></slot>
      </div>
      <p class="martial-content">
        <b
          v-if="testOptions.paperAnalyses"
        >{{ testData.test_sequence ? `${testData.test_sequence}.` : '' }}</b>
        <b
          v-else-if="testOptions.index && typeof index == 'number'"
        >{{ serial ? serial + 1 : index + 1 }}.</b>
        <span v-for="(item, index) in material_content" :key="index">
          <audioPlay
            v-if="item.type == 'mp3' && testData.material_audio.content && testData.material_audio.content[item.content]"
            :src="testData.material_audio.content[item.content]"
          ></audioPlay>
          <span v-else v-katex="item.name || item.content"></span>
        </span>
      </p>
      <p
        class="material-topic-answer"
        v-if="testData.material_topic_answer && testData.material_topic_answer.length"
      >
        <span
          class="topic-answer-item"
          v-for="(item, index) in testData.material_topic_answer"
          :key="index"
          v-katex="item"
        ></span>
      </p>
      <div class="martial-test">
        <single
          :class="{ 'test-information-simple': mode == 'simple', activeBg: matchActiveList(testData.id), disabled: isDisabled(testData.id) }"
          :testOptions="testOptions"
          :index="0"
          :testData="testData"
          ref="single"
          :expand="expand"
          :activeid="activeid"
          :operatingfloat="operatingfloat"
          :infoicon="infoicon"
          @testOpen="testOpen"
        >
          <template slot="topInfo" slot-scope="{ data }">
            <slot name="topInfo" :data="data" :index="[index]"></slot>
          </template>
          <template slot="middleInfo" slot-scope="{ data }">
            <slot name="middleInfo" :data="data" :index="[index]"></slot>
          </template>
          <template slot="bottomInfo" slot-scope="{ data }">
            <slot name="bottomInfo" :data="data" :index="[index]"></slot>
          </template>
          <template slot="bottomButtons" slot-scope="{ data }">
            <slot name="bottomButtons" :data="data" :index="[index]" :fade="fade"></slot>
          </template>
          <template slot="floatButtons" slot-scope="{ data }">
            <slot name="floatButtons" :data="data" :index="[index]" :fade="fade"></slot>
          </template>
          <template slot="topInfoRight" slot-scope="{ data }">
            <slot name="topInfoRight" :data="data" :index="[index]"></slot>
          </template>
        </single>
      </div>
    </div>
    <!-- 非材料题 -->
    <single
      v-else
      :class="{ activeBg: matchActiveList(testData.id), disabled: isDisabled(testData.id) }"
      :testOptions="testOptions"
      :testData="testData"
      :index="index"
      :len="len"
      ref="single"
      :serial="serial"
      :expand="expand"
      :activeid="activeid"
      :operatingfloat="operatingfloat"
      :move="move"
      :infoicon="infoicon"
      @testOpen="testOpen"
    >
      <template slot="topInfo" slot-scope="{ data }">
        <slot name="topInfo" :data="data" :index="[index]"></slot>
      </template>
      <template slot="middleInfo" slot-scope="{ data }">
        <slot name="middleInfo" :data="data" :index="[index]"></slot>
      </template>
      <template slot="bottomInfo" slot-scope="{ data }">
        <slot name="bottomInfo" :data="data" :index="[index]"></slot>
      </template>
      <template slot="bottomButtons" slot-scope="{ data, fade }">
        <slot name="bottomButtons" :data="data" :index="[index]" :fade="fade"></slot>
      </template>
      <template slot="floatButtons" slot-scope="{ data, fade }">
        <slot name="floatButtons" :data="data" :index="[index]" :fade="fade"></slot>
      </template>
      <template slot="topInfoRight" slot-scope="{ data }">
        <slot name="topInfoRight" :data="data" :index="[index]"></slot>
      </template>
    </single>
    <!-- 加入篮子动画 -->
    <testShadow :shadow="shadow"></testShadow>
    <!-- 拖拽释放容器 -->
    <div
      class="test-main-drop"
      v-if="dropView && myDropView"
      @drop="drop($event)"
      @dragover.stop="allDrag($event)"
      @dragenter.stop="dragHover($event, 1)"
      @dragleave.stop="dragHover($event, 0)"
    ></div>
  </div>
</template>

<script>
import utils from './utils'
import Vue from 'vue'
import single from './single'
import testShadow from './testShadow'
import audioPlay from './audioPlay'
export default {
  name: 'xes-question-single',
  props: {
    data: {
      //默认值
      type: [Object, Array],
      required: true
    },
    index: {
      //序号
      type: Number,
      default: 0
    },
    group: {
      //组序号
      type: Number
    },
    serial: {
      type: Number
    },
    len: {
      //默认值
      type: Number
    },
    options: {
      default: function () {
        return {}
      },
      type: Object
    },
    mode: {
      default: 'common',
      type: String
    },
    expand: {
      default: false,
      type: Boolean
    },
    dropView: {
      default: false,
      type: Boolean
    },
    move: {
      default: false,
      type: Boolean
    },
    activeid: {
      default: function () {
        return {}
      },
      type: Object
    },
    operatingfloat: {
      default: false,
      type: Boolean
    },
    activelist: {
      type: Array,
      default: function () {
        return []
      }
    },
    disabled: {
      type: [Boolean, Array],
      default: false
    },
    infoicon: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      shadow: {
        show: false,
        html: '',
        type: ''
      },
      modeConfig: {
        common: {
          material_id: true, //材料id
          material_content: true, //材料内容
          testId: true, //题id
          difficult: true, //难度
          isOriginal: true, //是否原题
          isObjective: true, //是否客观
          isVerify: true, //审核状态
          freeze: true, //冻结
          source: true, //来源
          index: true, //序号
          score: true, //分数
          stem: true, //题干
          answer: true, //答案
          analyze: true, //解析
          knowledge: true, //知识点
          use: true, //使用次数
          reply: true, //作答次数
          correctrate: true, //正确率
          download: true, //下载次数
          serial_num: true, //材料小题好
          type_name: true, //试题类型
          classify: true, //试题题类
          level_name: true, //能力层级
          category_trees: true //题型树
        },
        simple: {
          material_id: false, //材料id
          material_content: true, //材料内容
          testId: false, //题id
          difficult: false, //难度
          isOriginal: false, //是否原题
          isObjective: false, //是否客观
          isVerify: false, //审核状态
          freeze: false, //冻结
          source: false, //来源
          index: true, //序号
          serial_num: true, //材料小题好
          score: true, //分数
          stem: true, //题干
          answer: false, //答案
          analyze: false, //解析
          knowledge: false, //知识点
          use: false, //使用次数
          reply: false, //作答次数
          correctrate: false, //正确率
          download: false, //下载次数
          type_name: false, //试题类型
          classify: false, //试题题类
          level_name: true, //能力层级
          category_trees: true //题型树
        }
      },
      childDropView: false, //材料小题拖动释放区域显示
      myDropView: true, //自己的释放区域视图
      shadow: {
        show: false,
        html: '',
        type: 'shadowEnter'
      }
    }
  },
  methods: {
    setChildDropView (state) {
      this.childDropView = state
    },
    childDragStart (data, index) {
      if (!this.move) return
      let arr = !isNaN(this.group) ? [this.group, this.index, index] : [this.index, index]
      this.$emit('drag-start', data, arr)
    },
    childDragEnd (data, index) {
      if (!this.move) return
      let arr = !isNaN(this.group) ? [this.group, this.index, index] : [this.index, index]
      this.$emit('drag-end', data, arr)
    },
    childDragClick (data, index) {
      if (this.isDisabled(data.id)) return
      let arr = !isNaN(this.group) ? [this.group, this.index, index] : [this.index, index]
      this.$emit('drag-click', data, arr)
    },
    childDrop (data, index) {
      if (!this.move) return
      let arr = !isNaN(this.group) ? [this.group, this.index, index] : [this.index, index]
      this.$emit('drop', data, arr)
    },
    dragStart (e) {
      if (!this.move) return
      this.myDropView = false
      e.dataTransfer.setData('aaa', '')
      this.$emit('set-drop-view', true)
      let arr = !isNaN(this.group) ? [this.group, this.index] : [this.index]
      this.$emit('drag-start', this.testData, arr)
    },
    dragEnd (e) {
      if (!this.move) return
      this.myDropView = true
      this.$emit('set-drop-view', false)
      let arr = !isNaN(this.group) ? [this.group, this.index] : [this.index]
      this.$emit('drag-end', this.testData, arr)
    },
    dragClick (e) {
      if (this.testData.id && this.isDisabled(this.testData.id)) return
      let arr = !isNaN(this.group) ? [this.group, this.index] : [this.index]
      this.$emit('drag-click', this.testData, arr)
    },
    drop (e) {
      e.target.style = ''
      if (!this.move) return
      this.$emit('set-drop-view', false)
      let arr = !isNaN(this.group) ? [this.group, this.index] : [this.index]
      this.$emit('drop', this.testData, arr)
    },
    dragHover (e, type) {
      if (type == 1) {
        e.target.style.border = '1px dashed #5A75F6'
      } else {
        e.target.style = ''
      }
    },
    allDrag (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    fade (type, id) {
      if (id) {
        this.$refs.single.forEach(el => {
          if (el.testData.id == id) {
            el.shadowMove(type)
          }
        })
        return
      }
      this.shadow.show = true
      let str = this.$refs.entity.innerHTML
      str = str.replace(/&lt;/g, '<')
      str = str.replace(/&gt;/g, '>')
      let reg = /<script[^>]*>(.|\n)*?(?=<\/script>)<\/script>/gi
      this.shadow.html = str.replace(reg, '')
      this.shadow.type = type
    },
    matchActiveList (id) {
      let state = false
      this.activelist.forEach(el => {
        if (el == id) {
          state = true
          return
        }
      })
      return state
    },
    isDisabled (id) {
      if (typeof this.disabled == 'boolean') return this.disabled
      let state = false
      if (!id) {
        if (this.testData.id) {
          id = this.testData.id
        } else {
          return false
        }
      }
      this.disabled.forEach(el => {
        if (el == id) {
          state = true
        }
      })
      return state
    },
    open (show, id) {
      if (Array.isArray(this.$refs.single)) {
        this.$refs.single.forEach(el => {
          if (id) {
            if (id == el.testData.id) {
              el.toTestShow(show)
            }
          } else {
            el.toTestShow(show)
          }
        })
      } else {
        this.$refs.single.toTestShow(show)
      }
    },
    testOpen (val) {
      this.$emit('testOpen', val)
    }
  },
  computed: {
    testData () {
      let data = {}
      if (Array.isArray(this.data)) {
        this.data.forEach((el, index) => {
          if (index == 0) {
            data.material_id = el.material_id
            // data.material_content = utils.setContent(el.material_content)
            data.material_content = el.material_content
            data.question_list = []
            data.material_audio = el.material_audio
          }
          data.question_list.push(el)
        })
        return data
      } else if (this.data.question_list && !this.data.material_id) {
        let data = {}
        data.question_list = this.data.question_list
        data.material_id = this.data.question_list[0].material_id
        data.material_content = this.data.question_list[0].material_content
        data.material_audio = this.data.question_list[0].material_audio
        return data
      }
      return this.data
    },
    material_content () {
      let material_content = this.testData.material_content
      if (this.testData.highlight && !Array.isArray(this.testData.highlight)) {
        material_content = utils.setHighLight(material_content, this.testData.highlight.material_frag)
      }
      material_content = utils.setContent(this.testData.material_content)
      return utils.setContent(material_content)
    },
    testOptions () {
      let data = this.modeConfig[this.mode]
      data = { ...data, ...this.options }
      return data
    }
  },
  components: {
    single,
    testShadow,
    audioPlay
  }
}
</script>


// WEBPACK FOOTER //
// packages/question-single/src/index.vue